import React from 'react';
import { Route } from 'react-router-dom';

import Login from 'app/modules/login/login';
import Logout from 'app/modules/login/logout';
import Home from 'app/modules/home/home';
import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';
import PageNotFound from 'app/shared/error/page-not-found';
import CareerTable from 'app/main/setting/career/career-table';
import EditCareer from 'app/main/setting/career/edit-career';
import AgentTable from 'app/main/agent/agent-table';
import CreateAgent from 'app/main/agent/create-agent';
import ClientTable from 'app/main/client/client-table';
import CreateClient from 'app/main/client/create-client';
import InitialImportComponent from 'app/main/configuration/import/initial_import_component';
import CreateProduct from 'app/main/product/create-product';
import ProductTable from 'app/main/product/product-table';
import PersonTable from 'app/main/person/person-table';
import CreateContract from 'app/main/contract/create-contract';
import ContractTable from 'app/main/contract/contract-table';
import ContractNewTable from 'app/main/contract/contract-new-table';
import DispatchNoteTable from 'app/main/dispatch_note/dispatch-note-table';
import ConfigurationWidget from 'app/main/configuration/config/configuration-component';
import PaymentImport from 'app/main/payment/import/payment_import';
import CreateDispatchNote from 'app/main/dispatch_note/create-dispatch-note';
import PaymentTable from 'app/main/payment/payment-table';
import ProvisionTable from 'app/main/provision/provision-table';
import CreateProvision from 'app/main/provision/create-provision';
import ImportedProvisionFileTable from 'app/main/provision/imported-provision-file-table';
import Stornofond from 'app/main/setting/stornofond/stornofond';
import InsuranceCompanyTable from 'app/main/setting/insurance_company/insurance-company-table';
import CreateInsuranceCompany from 'app/main/setting/insurance_company/create-insurance-company';
import PerformancePage from 'app/main/agent/performance-page';
import EditImportedPayment from 'app/main/payment/edit-imported-payment';
import MailCompose from 'app/main/email/mail-compose';
import ProvisionSheetTable from 'app/main/provision-sheet/provision-sheet-table';
import MailInbox from 'app/main/email/mail-inbox';
import MailInboxDetail from 'app/main/email/mail-inbox-detail';
import DocumentInfo from 'app/main/document-info/document-info';
import DownloadDocument from 'app/main/download-document/download-document';
import AssistantTable from 'app/main/assistant/assistant-table';
import CreateAssistant from 'app/main/assistant/create-assistant';
import AgentPromotionTable from 'app/main/agent-promotion/agent-promotion-table';
import ClientNewsTable from 'app/main/client-news/client-news-table';
import CreateClientNews from 'app/main/client-news/create-client-news';
import ClientConfiguration from 'app/main/client-configuration/client-configuration';
import ClientMessageTable from 'app/main/client-request/client-message-table';
import CreateClientMessage from 'app/main/client-request/create-client-message';
import ClientRequestTable from 'app/main/client-message/client-request-table';
import CreateClientRequest from 'app/main/client-message/create-client-request';
import DruzstvoAppreciationTable from 'app/main/druzstvo-appreciation/druzstvo-appreciation';
import CreateDruzstvoAppreciation from 'app/main/druzstvo-appreciation/create-druzstvo-appreciation';
import ReportTable from 'app/main/report/report-table';
import BonusDeductionTable from 'app/main/bonus-deduction/bonus-deduction-table';
import CreateBonusDeduction from 'app/main/bonus-deduction/create-bonus-deduction';
import ProvisionSheetGroupTable from 'app/main/provision-sheet/provision-sheet-group-table';
import WaitingProvisionAgentTable from 'app/main/waiting-provision-agent/waiting-provision-agent-table';
import TopListTable from 'app/main/top-list/top-list-table';
import CompetitionTable from 'app/main/competition/competition-table';
import CreateCompetition from 'app/main/competition/create-competition';
import ContractAnniversaryTable from 'app/main/contract-anniversary/contract-anniversary-table';
import NfaCardTable from 'app/main/nfa-card/nfa-card-table';
import CreateNfaCard from 'app/main/nfa-card/create-nfa-card';
import ChangePasswordPage from 'app/client_zone/account/change-password-page';
import AdminTable from 'app/main/admin/admin-table';
import CreateAdmin from 'app/main/admin/create-admin';
import UpomienkaTable from 'app/main/upomienka/upomienka-table';

const loading = <div>loading ...</div>;

// const Account = Loadable({
//   loader: () => import(/* webpackChunkName: "account" */ 'app/modules/account'),
//   loading: () => loading,
// });
//
// const Admin = Loadable({
//   loader: () => import(/* webpackChunkName: "administration" */ 'app/modules/administration'),
//   loading: () => loading,
// });
const AppRoutes = () => {
  // const pageLocation = useLocation();
  // React.useEffect(() => {
  //   sendActivity(pageLocation.pathname);
  // }, [pageLocation]);
  return (
    <div className="view-routes">
      <ErrorBoundaryRoutes>
        <Route index element={<Home />} />
        <Route path="login" element={<Login />} />
        <Route path="logout" element={<Logout />} />
        <Route path="careers/:careerType" element={<CareerTable />} />
        <Route path="edit-career/:id" element={<EditCareer />} />
        <Route path="settings/stornofond" element={<Stornofond />} />
        <Route path="settings/insurance-company" element={<InsuranceCompanyTable />} />
        <Route path="create-insurance-company/:id" element={<CreateInsuranceCompany />} />

        <Route path="/agents" element={<AgentTable />} />
        <Route path="/create-agent/:id?" element={<CreateAgent />} />
        <Route path="/agents/performance/:id" element={<PerformancePage />} />
        <Route path="/agents/promotion" element={<AgentPromotionTable />} />

        <Route path="/assistants" element={<AssistantTable />} />
        <Route path="/create-assistant/:id?" element={<CreateAssistant />} />

        <Route path="/admins" element={<AdminTable />} />
        <Route path="/create-admin/:id?" element={<CreateAdmin />} />

        <Route path="/clients" element={<ClientTable />} />
        <Route path="/create-client/:id?" element={<CreateClient />} />

        {/*<Route path="/edit-agent/:id" element={<EditAgent />} />*/}

        <Route path="/configuration/import/initial-import" element={<InitialImportComponent />} />

        <Route path="/products" element={<ProductTable />} />
        <Route path="/create-product/:id?" element={<CreateProduct />} />

        <Route path="/persons" element={<PersonTable />} />

        <Route path="/contracts" element={<ContractTable />} />
        <Route path="/create-contract/:id?" element={<CreateContract />} />

        <Route path="/new-contracts" element={<ContractNewTable />} />
        <Route path="/create-new-contract/:id?" element={<CreateContract />} />

        <Route path="/dispatch-notes" element={<DispatchNoteTable />} />
        <Route path="/create-dispatch-note/:id?" element={<CreateDispatchNote />} />

        <Route path="/upomienky" element={<UpomienkaTable />} />

        <Route path="/configurations" element={<ConfigurationWidget />} />

        <Route path="/payment/import" element={<PaymentImport />} />
        <Route path="/payments" element={<PaymentTable />} />
        <Route path="/payments/edit-imported-payment/:id?" element={<EditImportedPayment />} />

        <Route path="/provisions" element={<ProvisionTable />} />
        <Route path="/provisions/create-provision/:id?" element={<CreateProvision />} />
        <Route path="/provision-files" element={<ImportedProvisionFileTable />} />

        <Route path="/provision-sheets" element={<ProvisionSheetTable />} />
        <Route path="/provision-sheet-groups" element={<ProvisionSheetGroupTable />} />
        <Route path="/provision-waiting" element={<WaitingProvisionAgentTable />} />

        <Route path="/mail/compose" element={<MailCompose />} />

        <Route path="/mail/inbox" element={<MailInbox />} />
        <Route path="/mail/inbox/:id?" element={<MailInboxDetail />} />

        <Route path="/document-info" element={<DocumentInfo />} />
        <Route path="/download-document" element={<DownloadDocument />} />

        <Route path="/client-news" element={<ClientNewsTable />} />
        <Route path="/create-client-news/:id?" element={<CreateClientNews />} />

        <Route path="/create-configuration/:key" element={<ClientConfiguration />} />
        <Route path="/client-requests" element={<ClientRequestTable />} />
        <Route path="/client-requests/1/:id" element={<CreateClientRequest />} />

        <Route path="/client-messages" element={<ClientMessageTable />} />
        <Route path="/client-messages/2/:id" element={<CreateClientMessage />} />

        <Route path="/druzstvo-appreciations" element={<DruzstvoAppreciationTable />} />
        <Route path="/create-druzstvo-appreciation/:id?" element={<CreateDruzstvoAppreciation />} />

        <Route path="/reports" element={<ReportTable />} />

        <Route path="/bonus-deductions" element={<BonusDeductionTable />} />
        <Route path="/create-bonus-deduction/:id?" element={<CreateBonusDeduction />} />

        <Route path="/top-list/:month?" element={<TopListTable />} />

        <Route path="/competitions" element={<CompetitionTable />} />
        <Route path="/create-competition/:id?" element={<CreateCompetition />} />

        <Route path="/contract-anniversaries" element={<ContractAnniversaryTable />} />

        <Route path="/change-password" element={<ChangePasswordPage />} />

        <Route path="/nfa-cards" element={<NfaCardTable />} />
        <Route path="/create-nfa-card/:id?" element={<CreateNfaCard />} />
        {/*<Route path="account">*/}
        {/*  <Route*/}
        {/*    path="*"*/}
        {/*    element={*/}
        {/*      <PrivateRoute hasAnyAuthorities={[AUTHORITIES.ADMIN, AUTHORITIES.USER]}>*/}
        {/*        <Account />*/}
        {/*      </PrivateRoute>*/}
        {/*    }*/}
        {/*  />*/}
        {/*  <Route path="register" element={<Register />} />*/}
        {/*  <Route path="activate" element={<Activate />} />*/}
        {/*  <Route path="reset">*/}
        {/*    <Route path="request" element={<PasswordResetInit />} />*/}
        {/*    <Route path="finish" element={<PasswordResetFinish />} />*/}
        {/*  </Route>*/}
        {/*</Route>*/}
        {/*<Route*/}
        {/*  path="admin/*"*/}
        {/*  element={*/}
        {/*    <PrivateRoute hasAnyAuthorities={[AUTHORITIES.ADMIN]}>*/}
        {/*      <Admin />*/}
        {/*    </PrivateRoute>*/}
        {/*  }*/}
        {/*/>*/}
        {/*<Route*/}
        {/*  path="*"*/}
        {/*  element={*/}
        {/*    <PrivateRoute hasAnyAuthorities={[AUTHORITIES.USER]}>*/}
        {/*      <EntitiesRoutes />*/}
        {/*    </PrivateRoute>*/}
        {/*  }*/}
        {/*/>*/}
        <Route path="*" element={<PageNotFound />} />
      </ErrorBoundaryRoutes>
    </div>
  );
};

export default AppRoutes;
